import sliderLoader from '../../vively/scripts/utils/slider-loader';
import $ from 'jquery';

const Categories = () => {
  if (!window.route || !/^category\/item/.test(window.route)) {
    return;
  }
  // Showing description
  $('#read-more button').click(function () {
    $('.article-content').removeClass('hidden');
    $(this).remove();
  });

  // Activating slider
  sliderLoader({
    slider: '#similar-practices .cards-slider',
    maxWidth: 767,
    settings: {
      slidesToShow: 2,
      arrows: false,
      dots: true,
      rows: 0,
      responsive: [
        {
          settings: { slidesToShow: 1 },
          breakpoint: 575
        }
      ]
    }
  });

  // Loading businesses
  const htmlTemplate = document.querySelector('#business-html');
  if (htmlTemplate) {
    const itemHtml = htmlTemplate.outerHTML;
    const error = () => $('#related-businesses').remove();
    const dataToHtml = data => data.reduce((html, item) => {
      const { description, title, state, image, key } = item;
      const $item = $(itemHtml);

      // Clearing style & linking
      $item.removeAttr('style').removeAttr('id');
      $item.find('a').attr('href', `${$item.find('a').data('href')}${key}`);

      // Updating content
      $item.find('.card-image img').attr('src', image);
      $item.find('.card-text').html(description);
      $item.find('.card-title').html(title);
      $item.find('.card-state').html(state);

      return html + $item[0].outerHTML;
    }, '');

    const $loader = $('#loader');
    $.ajax({
      url: `${window.location.pathname}/all?suppressHeaders=true&json=true`,
      success: (data, msg) => {
        if (msg === 'success' && Array.isArray(data)) {
          $loader.replaceWith(dataToHtml(data));
        } else {
          error();
        }
      },
      error
    })
      .then(() => sliderLoader({
        slider: '#related-businesses .cards-slider',
        maxWidth: 767,
        settings: {
          slidesToShow: 3,
          arrows: false,
          dots: true,
          rows: 0,
          responsive: [
            {
              settings: { slidesToShow: 2 },
              breakpoint: 670
            },
            {
              settings: { slidesToShow: 1 },
              breakpoint: 575
            }
          ]
        }
      }));
  }
};

export default Categories;




// WEBPACK FOOTER //
// ./categories/scripts/main.js